import moment, { Moment } from 'moment';
import {
  getNextAndPreviousTimelineItems,
  GetTimelineItemOverlapFreeTimesArgs,
  sortTimelineItems,
} from '@modules/timetable';
import { TimelineItemTypeType } from '@app-types/timetable';

export const getTimelineItemOverlapFreeTimes = ({
  timelineItems,
  groupId,
  startTime: previousStartTime,
  endTime: previousEndTime,
  duration,
}: GetTimelineItemOverlapFreeTimesArgs): {
  startTime: Moment;
  endTime: Moment;
} => {
  let startTime = previousStartTime.clone();
  let endTime = previousEndTime.clone();

  // Get timeline items in the same class (group)
  const timelineItemsInTheSameClass = timelineItems.filter((timelineItem) => timelineItem.groupID === groupId);

  if (timelineItemsInTheSameClass.length !== 0) {
    const newTimelineItem = {
      id: `dummy`,
      groupID: groupId,
      title: 'dummy',
      startTime,
      endTime,
      duration: 1,
      color: '',
      elementID: 'dummy',
      batchClassID: groupId,
      itemType: TimelineItemTypeType.subject,
      lecturerID: 'dummy',
      locationID: 'dummy',
      subjectName: '',
      published: false,
      batchName: 'dummy',
      batchClassName: 'dummy',
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      removeItem: () => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      moveItem: () => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      setEndTime: () => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      setStartTime: () => {},
      dbId: null,
    };

    // Sort the timeline items according to start time
    const sortedTimelineItems = sortTimelineItems({
      timelineItems: [...timelineItemsInTheSameClass, newTimelineItem],
    });

    // Get the next and previous timeline items for the current item
    const { previousItem, nextItem } = getNextAndPreviousTimelineItems({
      timelineItems: sortedTimelineItems,
      currentTimelineItemId: newTimelineItem.id,
    });

    let previousItemConflicts = false;
    let nextItemConflicts = false;
    if (previousItem && previousItem.endTime > startTime) {
      const hoursBetweenPreviousStartAndCurrentStart = moment
        .duration(startTime.diff(previousItem.startTime))
        .asHours();

      // If the new start time false in the first half of the previous item's entire duration, send the new item to left
      if (previousItem.duration / 2 > hoursBetweenPreviousStartAndCurrentStart) {
        nextItemConflicts = true;
      } else {
        previousItemConflicts = true;
      }
    }

    if (previousItem && nextItem && previousItemConflicts && nextItemConflicts) {
      startTime = previousItem.endTime;
      endTime = nextItem.endTime;
    } else if (previousItem && previousItemConflicts) {
      startTime = previousItem.endTime;
      endTime = startTime.clone().add(duration, 'h');
    } else if (nextItemConflicts) {
      endTime = previousItem?.startTime || nextItem?.startTime || endTime;
      startTime = endTime.clone().subtract(duration, 'h');
    }
  }

  return { startTime, endTime };
};
